import { useEffect, useState } from "react";
import API from "../../services/api";
import "./AdminOrder.css";

function AdminOrders() {

  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetchOrders(); 
  }, []);

  const fetchOrders = async () => {
    const res = await API.get("/api/admin/order/all");
    setOrders(res.data);
  };

  const updateStatus = async (id, status) => {
    try {
      await API.put(`/api/admin/order/${id}/status?status=${status}`);
      fetchOrders();
    } catch (err) {
      console.log(err);
    }
  };

  const cancelOrder = async (id) => {
    try {
      await API.put(`/api/order/cancel/${id}`);
      fetchOrders();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="admin-page">

      <h2 className="admin-title">📦 Admin Orders Panel</h2>

      {orders.map(order => (
        <div key={order.id} className="admin-card">

          {/* HEADER */}
          <div className="admin-header">
            <div>
              <h4>Order #{order.id}</h4>
              <p>{new Date(order.orderDate).toLocaleString()}</p>
            </div>

            <span className={`status ${order.orderStatus}`}>
              {order.orderStatus}
            </span>
          </div>

          {/* ITEMS */}
          <div className="admin-items">
            {order.items?.map(item => (
              <div key={item.productId} className="admin-item">

                <img
                  src={item.imageUrl || "/default.png"}
                  alt={item.productName}
                />

                <div>
                  <h5>{item.productName}</h5>
                  <p>Qty: {item.quantity}</p>
                  <p>₹ {item.price}</p>
                </div>

              </div>
            ))}
          </div>

          {/* ADDRESS */}
          <div className="admin-address">
            <h5>👤 {order.address?.fullName}</h5>
            <p>{order.address?.street}</p>
            <p>{order.address?.city}, {order.address?.state}</p>
            <p>{order.address?.pincode}</p>
          </div>

          {/* ACTIONS */}
          <div className="admin-actions">

            <select
              value={order.orderStatus}
              onChange={(e) => updateStatus(order.id, e.target.value)}
            >
              <option value="PENDING">PENDING</option>
              <option value="SHIPPED">SHIPPED</option>
              <option value="DELIVERED">DELIVERED</option>
            </select>

            {order.orderStatus === "PENDING" && (
              <button
                className="cancel-btn"
                onClick={() => cancelOrder(order.id)}
              >
                Cancel Order
              </button>
            )}

          </div>

        </div>
      ))}

    </div>
  );
}


export default AdminOrders;
